import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import styles from './NavigationLink.module.scss';

interface INavigationLink {
  children: ReactNode;
  to: string;
  className?: string;
  childrentext?: string;
}

export default function NavigationLink({
  children,
  to,
  className,
  childrentext,
}: INavigationLink): JSX.Element {
  return (
    <NavLink
      activeClassName={styles.active}
      to={to}
      className={classNames(styles.NavigationLink, className)}
      // @ts-ignore needed to prevent width change when bold
      childrentext={childrentext || children}
    >
      {children}
    </NavLink>
  );
}
